import ServiceDetail from "./ServiceDetail";

export default function SoftwareDevelopment() {
  return <ServiceDetail forcedSlug="software-development" />;
}
